import { z } from 'zod';
import { UserStatusSchema } from '../../../../entities/user/user.schema';
import { PlatformRoleSchema } from '../../../../entities/user/platform-role';
import { AvatarSchema } from '../../../../shared/avatar.schema';
import { SupportedLanguageSchema } from '../../../../shared/language.schema';
/**
 * SuperAdmin User Schema
 * Represents a system administrator with access to all tenants
 *
 * Note: SuperAdmin users are simplified compared to regular users:
 * - Always have userType: ['system_admin']
 * - Always have classification: 'internal'
 * - No department or role assignments (global access)
 * - No external organization (always internal)
 * - Stored in the SuperAdmin database
 */ export const SuperAdminUserSchema = z.object({
    _id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    email: z.email(),
    avatar: AvatarSchema.optional(),
    status: UserStatusSchema,
    /**
   * Was dieser Mensch an der Plattform darf (ADR 0042). Die Mitgliedschaft
   * hier sagt „gehört zur Plattform"; die Rolle sagt, welche Bereiche
   * offenstehen.
   */ platformRoles: z.array(PlatformRoleSchema),
    invitedAt: z.number().optional(),
    activatedAt: z.number().optional(),
    language: SupportedLanguageSchema.optional(),
    deletedAt: z.number().optional()
});

//# sourceMappingURL=superadmin-user.schema.js.map